<template>
  <v-dialog v-model="show" persistent max-width="450">
    <v-card>
      <v-card-title>Mark LCBO Distillery Reporting as filed</v-card-title>
      <v-divider/>

      <v-container>
        <v-row>
          <v-col cols="7" class="text-right">File for period end:</v-col>
          <v-col class="font-weight-bold">{{periodEnd | formatDate}}</v-col>
        </v-row>
        <v-row v-if="thisPeriod" class="warning--text">
          <v-col>Cannot file LCBO reports for the current period until the period ends.</v-col>
        </v-row>
        <template v-else>
          <v-row>
            <v-col cols="7" class="text-right">Due:</v-col>
            <v-col class="font-weight-bold">{{dueDate | formatDate}}</v-col>
          </v-row>
          <v-row>
            <v-col cols="7" class="text-right">
              Payment amount:
            </v-col>
            <v-col class="font-weight-bold">{{total | currency}}</v-col>
          </v-row>
          <v-row v-if="total && createReceipt">
            <v-col class="mx-1">
              An inventory receipt will be created for the taxes payable.
            </v-col>
          </v-row>
          <v-row>
            <v-col class="warning--text mx-1">
              This will mark your LCBO Distillery Reports as filed for this period.
              No further transactions affecting product sales will be allowed in this period.
            </v-col>
          </v-row>
        </template>
      </v-container>

      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving" :disabled="thisPeriod">File</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import {add,format,lastDayOfMonth} from 'date-fns';

export default {
  name: 'ReportsOntarioLCBOFile',
  props: {
    value: {type:Boolean, required:true}
  },
  data() {
    return {
      show: this.value,
      saving: false,
      thisPeriod: false,
      periodEnd: null,
      dueDate: null,
      total: 0,
      createReceipt: false
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    value() {
      this.show = this.value;
      if (this.show)
        this.init();
    },
  },
  methods: {
    async init() {
      let results = await this.$apiCall(`query ReportsOntarioSpiritsFile {
                                            ontarioPreferences {
                                              lcboPeriodEnd,createReceipt,lcboQuarterly
                                            }
                                           }`,
                                          {});
      if (results.error)
        return;

      this.createReceipt = results.data.ontarioPreferences.createReceipt;
      const lcboPeriodEnd = results.data.ontarioPreferences.lcboPeriodEnd;

      const date = lastDayOfMonth(lcboPeriodEnd !== '1999-12-31' ?
                                  add(new Date(lcboPeriodEnd),{days:2}) :  // Next period from last filed
                                  add(new Date(),{months:results.data.ontarioPreferences.lcboQuarterly ? -3 : -1}));   // end of last month

      this.periodEnd = format(add(date,{months:results.data.ontarioPreferences.lcboQuarterly?2:0}), 'yyyy-MM-dd');
      this.dueDate = format(add(date, {months:results.data.ontarioPreferences.lcboQuarterly?2:0,days:20}),'yyyy-MM-dd');
      this.thisPeriod = this.periodEnd > format(new Date(),'yyyy-MM-dd');
      results = await this.$apiCall(`query ReportsOntarioLCBOFile($date:Date!) {
                                             lcb2413(date:$date) {
                                                total {depositValue}
                                             },
                                             lcb2414(date:$date) {
                                               grandTotal {W},
                                             }
                                             lcb2415(date:$date) {
                                               totals {O},
                                             }
                                             lcb2416(date:$date) {
                                              grandTotal {S},
                                             }
                                           }`,
                                          {date:format(date,'yyyy-MM-')+'01'});
      if (!results.error)
        this.total = this.$roundNumber(results.data.lcb2413.total.depositValue) +
                     this.$roundNumber(results.data.lcb2414.grandTotal.W) +
                     this.$roundNumber(results.data.lcb2416.grandTotal.S) +
                     this.$roundNumber(results.data.lcb2415.totals.O);
    },
    async save() {
      this.saving = true;
      const results = await this.$apiCall(`mutation ReportsOntarioSpiritsFile($periodEnd:Date!, $amount:Float!) {
                                              lcboFile(periodEnd:$periodEnd, amount:$amount)
                                            }`,
                                          {periodEnd:this.periodEnd, amount:this.total});
      this.saving = false;
      if (!results.error) {
        this.$store.commit('setError', {message:'LCBO Distillery Reporting filed',type:'success'});
        this.$emit('filed', this.periodEnd);
        this.cancel();
      }
    },
    cancel() {
      this.show = false;
      this.$emit('input', false);
    },
  }
}
</script>